import { createAsyncThunk } from '@reduxjs/toolkit';
import blackboxService from 'api/blackboxService';
import { notifyApiError } from 'api/apiUtils';
import { notifyError, notifySuccess } from 'utils/notifications';

export const blackboxUpload = createAsyncThunk(
  'blackbox/blackboxUpload',
  async (payload, { rejectWithValue, extra: { i18n } }) => {
    try {
      const response = await blackboxService.blackboxUpload(payload);
      if (response === 'OK') {
        notifySuccess(
          i18n.t('datagate.external.blackbox.uploadSuccess')
        );
        return response;
      } else if (response === 'VIRUS_FOUND') {
        notifyError(i18n.t('datagate.external.upload.error.virusFound'));
        return rejectWithValue(response);
      } else {
        notifyError(i18n.t('datagate.external.upload.error.unknown'));
        return rejectWithValue(response);
      }
    } catch (err) {
      notifyApiError(i18n, err);
      return rejectWithValue(err);
    }
  }
);
